<span [class]="trackClasses()">
  <span [class]="fillClasses()" [style.width.%]="percent()"></span>
</span>
